var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FamilyOverviewCard',{staticClass:"mb-4"}),_c('BackgroundOverviewCard',{staticClass:"mb-4"}),_c('HistoryOverviewCard',{staticClass:"mb-4"}),_c('PersonalOverviewCard',{staticClass:"mb-4",attrs:{"item":_vm.peParty.overview}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }